import { render, staticRenderFns } from "./ScarletVideo.vue?vue&type=template&id=18e3cf04&lang=html"
import script from "./ScarletVideo.vue?vue&type=script&lang=js"
export * from "./ScarletVideo.vue?vue&type=script&lang=js"
import style0 from "./ScarletVideo.vue?vue&type=style&index=0&id=18e3cf04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports